<template>
  <v-container class="mt-4 pr-4" fluid>
    <v-row class="ml-2 mr-2">
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title class="text-h6">
            Programación
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              tile
              dark
              small
              @click="dialogAddTarea = true"
              class="mr-2"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              tile
              dark
              small
              @click="getCalendario()"
              class="mr-2"
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>

            <v-menu
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-sheet height="600">
              <v-calendar
                ref="calendar"
                :now="value"
                :value="value"
                :events="events"
                :event-color="getEventColor"
                color="primary"
                :type="type"
                v-model="focus"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
              >
                
                <template v-slot:day-body="{ date, week }">
                  <div
                    class="v-current-time"
                    :class="{ first: date === week[0].date }"
                    :style="{ top: nowY }"
                  ></div>
                </template>
              </v-calendar>

              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
              >
                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    :color="selectedEvent.color"
                    dark
                    dense
                  >
                    <!-- <v-btn icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn> -->
                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <label><strong>Categoría</strong></label>
                    <br/>
                    <div  style="white-space: pre-line">{{ selectedEvent.name }}</div>
                    <br/>
                    
                    <label><strong>Coach</strong></label>
                    <br/>
                    <div  style="white-space: pre-line">{{ selectedEvent.nombre_completo }}</div>
                    
                    <br/>
                    <label><strong>Horario</strong></label>
                    <br/>
                    <span >{{ selectedEvent.hora_inicio }} a {{ selectedEvent.hora_fin }}</span>

                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      color="secondary"
                      @click="selectedOpen = false"
                    >
                      Cerrar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="secondary"
                      @click="eliminar( selectedEvent )"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>

            </v-sheet>
          </v-card-text>
        </v-card>

        <!-- Dialog de carga -->
        <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
        <carga                v-if="cargar"/>


        <v-dialog
          v-model="dialogAddTarea" 
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
        >
          <v-card>
            <v-card-title primary-title>
              Agregar clase
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="tarea.dia"
                label="Día"
                dense
                type="date"
                filled
              ></v-text-field>

              <v-text-field
                v-model="tarea.limite_alumnos"
                label="Limite alumnos"
                dense
                filled
                class="mt-2"
              ></v-text-field>

              <v-text-field
                v-model="tarea.hora_inicio"
                label="Hora"
                dense
                type="time"
                filled
                class="mt-2"
              ></v-text-field>

              <v-text-field
                v-model="tarea.hora_fin"
                label="Hora"
                dense
                type="time"
                filled
                class="mt-2"
              ></v-text-field>


              <v-autocomplete
                filled
                dense
                clearable
                v-model="tarea.idcoach"
                :items="coachs"
                label="Selecciona el coach"
                persistent-hint
                item-text="nombre_completo"
                item-value="idusuarios"
              >
              </v-autocomplete>

              <v-autocomplete
                filled
                dense
                clearable
                v-model="tarea.idcategorias"
                :items="categorias"
                label="Selecciona la categoría"
                persistent-hint
                item-text="categoria"
                item-value="idcategorias"
              >
              </v-autocomplete>

            </v-card-text>
            <v-card-actions>
              <v-btn 
                color="black"
                tile
                small
                dark
                @click="dialogAddTarea = false"
              >
                <v-icon left small>mdi-cancel</v-icon>
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn 
                color="success"
                tile
                small
                dark
                @click="guardar()"
              >
                <v-icon left small>mdi-content-save</v-icon>
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    computed: {
      ...mapGetters('login',['getLogeadoFitHouse','getdatosUsuarioFitHouse']),

      cal () {
        return this.ready ? this.$refs.calendar : null
      },
      nowY () {
        console.log( this.cal.times.now )
        console.log( this.cal.timeToY(this.cal.times.now) )
        return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
      },
    },

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      motivo: '',

      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      events: [],
      focus: '',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      
      dialogAddTarea: false,
      tarea:{
        dia: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        hora_inicio: null,
        hora_fin: null,
        idcoach:0,
        idcategorias:0,
        limite_alumnos:0,
      },
      coachs:[],
      value: '',
      ready: false,

      categorias:[],

      type: 'week',
      typeToLabel: {
        week: 'Week',
        day: 'Day',
      },
    }),

    created(){
      this.getCalendario()
      this.getCoach()
      this.getCategorias()
    },

    mounted () {
      this.$refs.calendar.checkChange()
      this.ready = true
      this.scrollToTime()
      this.updateTime()
    },

    methods:{

      getCoach( ){
        this.cargar = true
        // Obtener todos los ciclos
        this.$http.get('coachs.activos' ).then(response=>{
          this.coachs = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCategorias( ){
        this.cargar = true
        this.categorias = []
        // Obtener todos los ciclos
        this.$http.get('categorias.list' ).then(response=>{
          this.categorias = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCalendario( ){
        this.cargar = true
        // Obtener todos los ciclos
        this.$http.get('programacion').then(response=>{
          this.events = response.body
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      guardar( ){
        this.cargar = true

        // Obtener todos los ciclos
        this.$http.post('programacion.add', this.tarea ).then(response=>{
          this.dialogAddTarea = false
          this.tarea.hora = null
          this.tarea.hora_fin = null
          this.tarea.nota = ''
          this.tarea.accion = null
          this.getCalendario()
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      eliminar( data ){
        this.cargar = true
        // Obtener todos los ciclos
        this.$http.put('programacion.eliminar/' + data.idprogramacion ).then(response=>{
          this.selectedOpen = false
          this.getCalendario()
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },


      getEventColor (event) {
        return event.color
      },

      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      getCurrentTime () {
        return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
      },
      scrollToTime () {
        const time = this.getCurrentTime()
        const first = Math.max(0, time - (time % 30) - 30)

        this.cal.scrollToTime(first)
      },
      updateTime () {
        setInterval(() => this.cal.updateTimes(), 60 * 1000)
      },
    }
  }
</script>
<style lang="scss" scoped>
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
